// extracted by mini-css-extract-plugin
module.exports = {"open":"_2sS9sx","past":"_1QP8_u","date":"ZAy-ET","time":"_1UoW_L","title":"_3Wckzl","sections":"_1qntXo","section":"_2WweLn","section-title":"_20d_G1"};